import { render } from "./CountBox.vue?vue&type=template&id=dff9c230&scoped=true"
import script from "./CountBox.vue?vue&type=script&lang=js"
export * from "./CountBox.vue?vue&type=script&lang=js"

import "./CountBox.vue?vue&type=style&index=0&id=dff9c230&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff9c230"]])

export default __exports__